import React from 'react';
import { GiftIcon, AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { StickyNote } from './StickyNote';
import { EbookMockup } from './EbookMockup';
type Bonus = {
  number: string;
  title: string;
  description: string;
  image?: string;
  mockup?: {
    title: string;
    highlight?: string;
    background: string;
  };
};
export function BonusStack() {
  const bonuses: Bonus[] = [{
    number: '01',
    title: 'Guía Antiinflamatoria',
    description: 'Guía completa para reducir hinchazón, inflamación, fatiga y pesadez desde adentro.',
    image: 'https://cdn.magicpatterns.com/uploads/ovefJNqAaXqA2RMcz8zpK8/MOCKUP_BONO_ANTIINFLAMACION.png'
  }, {
    number: '02',
    title: 'Stretching y Movilidad',
    description: 'Estiramiento post-entreno, movilidad matutina y rutinas de alivio de tensiones.',
    image: 'https://cdn.magicpatterns.com/uploads/fBHsNJEtCAAbheMqEs6PrX/MOCKUP_BONO_STRETCHING.png'
  }, {
    number: '03',
    title: 'Sueño y Recuperación',
    description: 'Guía para dormir mejor, recuperarte más rápido y sentirte con más energía.',
    mockup: {
      title: 'Dormí Mejor y Recuperate',
      highlight: 'En 7 Días',
      background: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=400&h=600&fit=crop'
    }
  }, {
    number: '04',
    title: 'Snacks Saludables',
    description: 'Guía de snacks saludables para antojos, pre-entreno, post-entreno y entre comidas.',
    image: 'https://cdn.magicpatterns.com/uploads/rhLmgD4kyzFAgDRoAAzSWn/MOCKUP_BONO_SNACKS.png'
  }, {
    number: '05',
    title: 'Meal Prep',
    description: 'Sistema paso a paso para preparar comidas para toda la semana en una sola sesión de cocina.',
    image: 'https://cdn.magicpatterns.com/uploads/fPHxvzRNsSn24p7dCmfe8S/MOCKUP_BONO_MEAL_PREP.png'
  }, {
    number: '06',
    title: 'Lista de Supermercado',
    description: 'Lista de compras organizada con ingredientes accesibles para ahorrar tiempo y dinero.',
    image: 'https://cdn.magicpatterns.com/uploads/hxVHng7TmjtRtpVCr6PP31/MOCKUP_LISTA_SUPER.png'
  }, {
    number: '07',
    title: '54 Recetas Saludables',
    description: 'Desayunos, almuerzos, cenas y postres saludables sin cocinar complicado.',
    image: 'https://cdn.magicpatterns.com/uploads/efyMyLTf4pqAhVc6mxRwKb/MOCKUP_BONO_54_RECETAS.png'
  }, {
    number: '08',
    title: 'Hábitos Duraderos',
    description: 'Sistema para mantener constancia y resultados a largo plazo sin abandonar.',
    image: 'https://cdn.magicpatterns.com/uploads/pz9waFDCtPvdzjvU58KyxS/MOCKUP_BONO_HABITOS.png'
  }, {
    number: '09',
    title: 'Licuados e Infusiones',
    description: 'Smoothies, jugos, aguas saborizadas e infusiones para energía, hidratación y recuperación.',
    image: 'https://cdn.magicpatterns.com/uploads/hY9xi9o9AP4JGNS526ZbJX/MOCKUP_GUIA_DE_BATIDOS.png'
  }, {
    number: '10',
    title: 'Alimentación Completa',
    description: 'Plan de comidas de 14 días diseñado para tonificar, bajar grasa, energía y recuperación.',
    image: 'https://cdn.magicpatterns.com/uploads/dwkRUQUL97ugAoMMtN4maX/MOCKUP_BONO_14_DIAS_DE_COMIDA.png'
  }];
  return <section className="py-12 md:py-16 bg-white relative overflow-hidden" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-4" data-id="element-17">
            🎁 Y ADEMÁS HOY TE LLEVÁS 10 BONOS GRATIS
          </h2>
          <div className="inline-block bg-brand-pink-600 text-white px-6 py-3 rounded-full font-bold text-lg" data-id="element-18">
            ⚠️ SOLO DISPONIBLES DURANTE 24 HORAS
          </div>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-3 mt-8 relative" data-id="element-19">
          <StickyNote color="yellow" rotation={2} className="absolute -top-8 -right-4 z-10 hidden md:block" data-id="element-20">
            Oferta 24 hs
          </StickyNote>

          {bonuses.map((bonus, i) => <div key={i} className="bg-cream-50 rounded-xl p-3 shadow-sm hover:shadow-md transition-shadow border border-brand-pink-100 flex items-center gap-4" data-id="element-21">
              <div className="w-16 h-24 flex-shrink-0 transform rotate-2 flex items-center justify-center" data-id="element-22">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-md" data-id="element-23" /> : bonus.mockup ? <EbookMockup title={bonus.mockup.title} highlight={bonus.mockup.highlight} background={bonus.mockup.background} className="w-full h-full" data-id="element-24" /> : null}
              </div>

              <div className="flex-1 text-left" data-id="element-25">
                <div className="flex items-center justify-between mb-1" data-id="element-26">
                  <div className="inline-block bg-brand-pink-600 text-white px-2 py-0.5 rounded text-[10px] font-bold tracking-wide" data-id="element-27">
                    BONUS {bonus.number}
                  </div>
                  <div className="inline-block bg-cream-200 px-2 py-0.5 rounded text-[9px] font-bold text-gray-900" data-id="element-28">
                    GRATIS
                  </div>
                </div>
                <h3 className="text-sm font-bold text-gray-900 mb-1 leading-tight" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-xs text-gray-600 leading-snug line-clamp-2" data-id="element-30">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* DRAMATIC PRICE LEDGER — BIG FOMO */}
        <div className="mt-12 md:mt-16 bg-gradient-to-br from-gray-900 via-gray-900 to-black text-white rounded-3xl p-8 md:p-14 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.6)] relative overflow-hidden border-2 border-brand-pink-600/40" data-id="element-31">
          {/* Subtle decorative gift icon */}
          <div className="absolute -top-6 -right-6 opacity-[0.08]" data-id="element-32">
            <GiftIcon className="w-48 h-48 text-brand-pink-500" data-id="element-33" />
          </div>

          {/* Pulsing "now" indicator */}
          <div className="flex justify-center mb-4" data-id="element-34">
            <div className="inline-flex items-center gap-2 bg-rose-500/15 border border-rose-500/50 text-rose-300 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest" data-id="element-35">
              <span className="relative flex h-2 w-2" data-id="element-36">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75" data-id="element-37" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-rose-500" data-id="element-38" />
              </span>
              EN VIVO · 77 reservas hoy
            </div>
          </div>

          <h3 className="font-display text-3xl md:text-5xl lg:text-6xl mb-3 text-center leading-tight" data-id="element-39">
            🚨 ÚLTIMA OPORTUNIDAD
          </h3>
          <p className="text-center text-base md:text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-40">
            Programa Wall Pilates + 10 Bonos exclusivos · Acceso de por vida
          </p>

          <div className="relative text-center max-w-3xl mx-auto" data-id="element-41">
            {/* Seats progress bar */}
            <div className="max-w-md mx-auto mb-8" data-id="element-42">
              <p className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-43">
                Quedan <span className="text-brand-pink-400" data-id="element-44">23 lugares</span>
              </p>
              <p className="text-xs md:text-sm text-gray-400 mb-3" data-id="element-45">
                con este descuento
              </p>
              <div className="w-full h-3 bg-gray-700 rounded-full overflow-hidden" data-id="element-46">
                <div className="h-full bg-gradient-to-r from-brand-pink-500 to-brand-pink-400 rounded-full" style={{
                width: '77%'
              }} data-id="element-47" />
              </div>
              <p className="text-xs text-gray-500 mt-2 font-medium" data-id="element-48">
                77 de 100 ya reservaron su lugar hoy
              </p>
            </div>

            <p className="text-xs md:text-sm uppercase tracking-widest text-gray-400 mb-2" data-id="element-49">
              Valor real total
            </p>
            <p className="text-3xl md:text-5xl font-bold line-through text-gray-500 mb-6" data-id="element-50">
              $139.890
            </p>

            <div className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-400/40 text-emerald-200 px-4 py-2 rounded-full text-xs md:text-sm font-bold mb-4" data-id="element-51">
              ▶️ Incluye videos demostrativos de cada ejercicio
            </div>

            <p className="text-xs md:text-sm uppercase tracking-widest text-brand-pink-400 font-bold mb-2" data-id="element-52">
              Hoy te lo llevás por solo
            </p>
            <p className="text-7xl md:text-8xl lg:text-9xl font-black text-brand-pink-500 mb-4 leading-none" style={{
            textShadow: '0 0 60px rgba(236, 72, 153, 0.45), 0 0 100px rgba(236, 72, 153, 0.25)'
          }} data-id="element-53">
              $16.990
              <span className="text-2xl md:text-3xl font-bold align-top ml-2 text-brand-pink-300" data-id="element-54">
                ARS
              </span>
            </p>

            <div className="inline-flex items-center gap-2 bg-yellow-400 text-gray-900 px-5 py-2.5 rounded-full text-base md:text-lg font-extrabold mb-3 shadow-lg" data-id="element-55">
              💰 AHORRÁS $122.900 · 88% OFF
            </div>

            <div className="flex justify-center mb-8" data-id="element-56">
              <div className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-400/40 text-emerald-200 px-3 py-1.5 rounded-full text-xs md:text-sm font-medium" data-id="element-57">
                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full" data-id="element-58" />
                Lucía de Córdoba acaba de reservar · hace 2 min
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8" data-id="element-59">
              <span className="bg-rose-500/20 border border-rose-500/40 text-rose-200 px-4 py-2 rounded-full text-xs md:text-sm font-bold flex items-center gap-1.5" data-id="element-60">
                <AlertTriangleIcon className="w-3.5 h-3.5" data-id="element-61" />
                Solo por hoy
              </span>
              <span className="bg-white/10 border border-white/20 text-white px-4 py-2 rounded-full text-xs md:text-sm font-bold" data-id="element-62">
                Quedan 23 lugares
              </span>
              <span className="bg-brand-pink-500/20 border border-brand-pink-400/40 text-brand-pink-200 px-4 py-2 rounded-full text-xs md:text-sm font-bold" data-id="element-63">
                10 bonos gratis
              </span>
              <span className="bg-emerald-500/20 border border-emerald-400/40 text-emerald-200 px-4 py-2 rounded-full text-xs md:text-sm font-bold" data-id="element-64">
                Acceso inmediato
              </span>
            </div>

            <CTAButton size="large" data-id="element-65">QUIERO EMPEZAR AHORA</CTAButton>

            <p className="text-xs md:text-sm text-gray-400 mt-4" data-id="element-66">
              🛡️ Garantía 7 días · Si no te encanta te devolvemos el 100%
            </p>
          </div>
        </div>
      </div>
    </section>;
}